// const config = useAppConfig();

export const fire_event = (event) => {
    // send Google Analytics event

    //console.log('📈 got event', typeof event, event)

    if (useAppConfig().RUN_MODE === 'development') {
        console.debug(`skipping gtag event (dev mode): ${event}`)
        return
    }

    try {
        gtag('event', event)
    } catch (error) {
        console.error('error firing gtag event', error)
    }
}
